
import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Button } from '../ui/button';
import { format, getISOWeek, getISOWeekYear, startOfISOWeek } from 'date-fns';
import fr from 'date-fns/locale/fr';
import { parseLocalDate, toLocalISODate } from '@/store/weekStore';

interface WeeklyHeaderProps {
  weekStartDate: string; // ISO string (YYYY-MM-DD)
  weekEndDate: string;   // ISO string (YYYY-MM-DD)
  onSelectWeek: (weekStartISO: string) => void;
}

export const WeeklyHeader: React.FC<WeeklyHeaderProps> = ({
  weekStartDate,
  weekEndDate,
  onSelectWeek,
}) => {
  const getWeekInputValue = (isoDate: string) => {
    const date = parseLocalDate(isoDate);
    const year = getISOWeekYear(date);
    const week = getISOWeek(date);
    return `${year}-W${week.toString().padStart(2, '0')}`;
  };

  const handleWeekChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value; // ex: 2024-W30
    if (!value) return;
    const [yearStr, weekStr] = value.split('-W');
    const year = Number(yearStr);
    const week = Number(weekStr);
    // 4 janvier est toujours en semaine ISO 1
    const jan4 = new Date(year, 0, 4, 12, 0, 0);
    const weekOne = startOfISOWeek(jan4);
    weekOne.setDate(weekOne.getDate() + (week - 1) * 7);
    onSelectWeek(toLocalISODate(weekOne));
  };

  return (
    <div className="flex items-center justify-between gap-4 flex-wrap">
      <Link to="/">
        <Button variant="outline" size="sm">
          <Home className="h-4 w-4 mr-2" />
          Accueil
        </Button>
      </Link>

      <div className="text-center flex-1 min-w-[200px]">
        <h1 className="text-2xl font-bold text-gray-900">Ma semaine</h1>
        <p className="text-muted-foreground whitespace-nowrap">
          {format(parseLocalDate(weekStartDate), "d MMM", { locale: fr })} - {format(parseLocalDate(weekEndDate), "d MMM yyyy", { locale: fr })}
        </p>
      </div>

      <input
        type="week"
        className="border rounded-md px-2 py-1 text-sm dark:bg-gray-800 dark:border-gray-700"
        value={getWeekInputValue(weekStartDate)}
        onChange={handleWeekChange}
      />
    </div>
  );
};
